import {baseQaConfig} from './qa.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const baseStagingConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseQaConfig, {
  environmentName: "Prism Staging Environment",
  ionicEnvName: 'staging',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/base/staging.config.ts